<script>
import Vue from 'vue'
import { MessageBox } from 'bxs-ui-vue'
import { getLocalStorage, setLocalStorage } from 'common/js/common'
Vue.use(MessageBox)

export default {
  name: 'WarmPrompt',
  props: {
    targetKey: {
      type: String,
      default: ''
    }
  },
  created () {
    this.ls_ley = this.targetKey
      ? `WeiyiStat_${this.targetKey}_warm`
      : 'WeiyiStat_pbr_warm'
    if (this.checkDisplay()) {
      this.$messagebox({
        title: '温馨提示',
        message:
          '本计划书非保险销售宣传资料，仅供保险从业人员学习、交流使用，不得用于任何商业用途；计划书不构成投保任何保险的依据，亦不构成投保任何保险的要约或要约邀请。',
        messageAlign: 'left',
        confirmButtonText: '知道了',
        showCancel: false
      })
        .then(() => {
          console.log('确定')
        })
        .catch(() => {
          console.log('取消')
        })
    }
  },
  methods: {
    checkDisplay () {
      let isFirst = localStorage.getItem(this.ls_ley)
      if (isFirst) return false
      localStorage.setItem(this.ls_ley, true)
      return true
    }
  }
}
</script>
<template>
  <div />
</template>